import Nav from "@/components/site/Nav";
import styles from "../Header.module.css";

export default function HeaderNav() {

	return (
		<Nav
			buttonProps={{
				filled: true
			}}
			className={styles.HeaderNav}
		/>
	);
}